@let refreshIntervalOptions = (refreshIntervalOptions$ | async) ?? [];

<h1 mat-dialog-title>
  {{
    (injectData.editData ? 'button.editContext' : 'button.addContext')
      | translate: { context: 'widget.' + injectData.type + '.name' | translate }
  }}
</h1>
<form #editForm [formGroup]="formGroup" (ngSubmit)="submit()" #form="ngForm">
  <div mat-dialog-content>
    <div class="col-12 mb-3">
      <span class="dialog-section"
        ><mat-icon>description</mat-icon> {{ 'system.dialogSection.generalInformation' | translate }}</span
      >
    </div>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'page.widgetContent.addEditDialog.title' | translate }}</mat-label>
      <input matInput [formControl]="formGroup.controls.title" />
      <mat-error [control]="formGroup.controls.title"></mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'page.widgetContent.addEditDialog.subtitle' | translate }}</mat-label>
      <input matInput [formControl]="formGroup.controls.subtitle" />
      <mat-error [control]="formGroup.controls.subtitle"></mat-error>
    </mat-form-field>

    @if (refreshIntervalOptions.length) {
      <mat-dropdown
        [formControl]="formGroup.controls.refreshIntervalDropdown"
        [options]="refreshIntervalOptions"
        [configurationInput]="refreshIntervalDropdownConfiguration"
        [isFormSubmitted]="form.submitted"
      ></mat-dropdown>
    }

    <div>
      <mat-dropdown
        [formControl]="formGroup.controls.subDashboardId"
        [options]="store.subDashboards()"
        [configurationInput]="subDashboardDropdownConfiguration"
        [isFormSubmitted]="form.submitted"
      ></mat-dropdown>
    </div>

    @if (formGroup.controls.subDashboardId.value.length) {
      <div>
        <mat-dropdown
          [formControl]="formGroup.controls.subDashboardWindowSize"
          [options]="subDashboardWindowSizeOptions"
          [configurationInput]="subDashboardWindowSizeDropdownConfiguration"
          [isFormSubmitted]="form.submitted"
        ></mat-dropdown>
      </div>
    }

    @for (input of visibleInputsInOrder(); let index = $index; track index) {
      @if (input === 'filterSection') {
        <div [class.mb-4]="modeNamesOfWidget().length !== 1">
          <filter-mode-selection-and-ordering-panel
            [filterModeOrder]="filterModeOrder"
            [modeNamesOfWidget]="modeNamesOfWidget()"
          >
          </filter-mode-selection-and-ordering-panel>
        </div>

        @for (sectionData of filterSectionData; track sectionData.modeName) {
          <div [class.mb-4]="sectionData.filters.length">
            <configure-filters-of-a-mode-panel
              [modeName]="sectionData.modeName"
              [configurationsOfAdvancedFilterInputs]="sectionData.filters"
              [typeBasedConfiguration]="typeBasedConfiguration()"
              [widgetType]="injectData.type"
              [filterSuppression]="sectionData.matchingFilterSuppression"
            >
            </configure-filters-of-a-mode-panel>
          </div>
        }
      } @else {
        <ng-template
          [ngTemplateOutlet]="input.template"
          [ngTemplateOutletContext]="{
            isFormSubmitted: form.submitted,
            formControl: input.formControl,
            widgetSpecificContext: input.widgetSpecificContext,
          }"
        ></ng-template>
      }
    }

    <mat-expansion-panel class="mt-2">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="me-2">display_settings</mat-icon>
          {{ 'system.dialogSection.displayConfiguration' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <p>
        <mat-checkbox [formControl]="formGroup.controls.isLastUpdatedLabelShown"
          >{{ 'page.widgetContent.addEditDialog.isLastUpdatedLabelShown' | translate }}
        </mat-checkbox>
      </p>
      <p>
        <mat-checkbox [formControl]="formGroup.controls.isAutoScrollEnabled"
          >{{ 'page.widgetContent.addEditDialog.isAutoScrollEnabled' | translate }}
        </mat-checkbox>
      </p>

      <mat-card class="mb-4">
        <mat-card-content class="pb-0">
          <div class="d-flex gap-10">
            <label>{{ 'page.widgetContent.addEditDialog.zoom' | translate }}:</label>
            <label>{{ formGroup.controls.zoom.value }}%</label>
          </div>
          <mat-slider class="w-100 mx-0" discrete [max]="200" [min]="50" [step]="5">
            <input
              matSliderThumb
              [formControl]="formGroup.controls.zoom"
              [value]="formGroup.controls.zoom.value"
              (valueChange)="formGroup.controls.zoom.setValue($event)"
            />
          </mat-slider>
        </mat-card-content>
      </mat-card>

      <div class="f-12 mb-3">
        <app-info-message
          icon="auto_awesome"
          text="{{
            'page.widgetContent.addEditDialog.positionInfo'
              | translate
                : {
                    x: ('page.widgetContent.addEditDialog.xPosition' | translate),
                    width: ('page.widgetContent.addEditDialog.width' | translate),
                    y: ('page.widgetContent.addEditDialog.yPosition' | translate),
                    height: ('page.widgetContent.addEditDialog.height' | translate),
                    cellHeight: '10px',
                  }
          }}"
        ></app-info-message>
      </div>
      <div class="d-flex gap-10">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'page.widgetContent.addEditDialog.xPosition' | translate }}</mat-label>
          <input matInput type="number" [formControl]="formGroup.controls.x" />
          <mat-error [control]="formGroup.controls.x"></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'page.widgetContent.addEditDialog.yPosition' | translate }}</mat-label>
          <input matInput type="number" [formControl]="formGroup.controls.y" />
          <mat-error [control]="formGroup.controls.y"></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'page.widgetContent.addEditDialog.width' | translate }}</mat-label>
          <input matInput type="number" [formControl]="formGroup.controls.w" />
          <mat-error [control]="formGroup.controls.w"></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'page.widgetContent.addEditDialog.height' | translate }}</mat-label>
          <input matInput type="number" [formControl]="formGroup.controls.h" />
          <mat-error [control]="formGroup.controls.h"></mat-error>
        </mat-form-field>
      </div>
      <button
        [class]="marginTopIfDisplayConfigHasError$ | async"
        mat-flat-button
        type="button"
        (click)="resetToDefaultValues()"
      >
        {{ 'page.widgetContent.addEditDialog.resetToDefault' | translate }}
      </button>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="isActionTrackerModuleAllowed()" class="mt-2">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="me-2 material-icons-outlined">note_add</mat-icon>
          {{ 'page.widgetContent.addEditDialog.actionTrackerConfiguration' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div>
        <mat-dropdown
          [options]="boards"
          [configurationInput]="actionCreateDefaultBoardIdConfiguration"
          [formControl]="formGroup.controls.actionCreateDefaultBoardId"
          (search)="getBoard($event)"
        >
        </mat-dropdown>

        <mat-dropdown
          [options]="itemTypes"
          [configurationInput]="actionCreateDefaultItemTypeIdConfiguration"
          [formControl]="formGroup.controls.actionCreateDefaultItemTypeId"
        >
        </mat-dropdown>

        <mat-dropdown
          [options]="itemCategories"
          [configurationInput]="actionCreateDefaultItemCategoryIdConfiguration"
          [formControl]="formGroup.controls.actionCreateDefaultItemCategoryId"
        >
        </mat-dropdown>
      </div>
    </mat-expansion-panel>

    @if (isOeeTrackerModuleAllowed()) {
      <mat-expansion-panel class="mt-2">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon class="me-2 material-icons-outlined">factory</mat-icon>
            {{ 'page.widgetContent.addEditDialog.openDfPageConfiguration.panelHeader' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <open-df-page-configuration
          [formControl]="formGroup.controls.openDfPageConfiguration"
        ></open-df-page-configuration>
      </mat-expansion-panel>
    }
  </div>

  <mat-dialog-actions align="end">
    <button matButton="tonal" type="button" mat-dialog-close>
      {{ 'button.cancel' | translate }}
    </button>
    <button mat-flat-button type="submit">
      {{
        (injectData.editData
          ? 'page.widgetContent.addEditDialog.editTitle'
          : 'page.widgetContent.addEditDialog.addTitle'
        ) | translate
      }}
    </button>
  </mat-dialog-actions>
</form>

<ng-template #woOEEMetricLayoutMultiSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.woOEEMetricLayoutMultiSelectDropdown"
    [options]="woOEEMetricLayoutOptions"
    [configurationInput]="woOEEMetricLayoutMultiSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #woOEEChartTypeSingleSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.woOEEChartTypeSingleSelectDropdown"
    [options]="woOEEChartTypeOptions"
    [configurationInput]="woOEEChartTypeSingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #oeeCalculationLevelSingleSelectDropdown>
  @if (oeeCalculationLevelAccess()) {
    <mat-dropdown
      [formControl]="formGroup.controls.oeeCalculationLevelSingleSelectDropdown"
      [options]="oeeCalculationLevelOptions"
      [configurationInput]="oeeCalculationLevelSingleSelectDropdownConfiguration"
      [isFormSubmitted]="form.submitted"
    ></mat-dropdown>
  }
</ng-template>

<ng-template #checkInLogsGroupingSingleSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.checkInLogsGroupingSingleSelectDropdown"
    [options]="checkInLogsGroupingOptions"
    [configurationInput]="checkInLogsGroupingSingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #checkInLogsDisplayConfigurationMultiSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.checkInLogsDisplayConfigurationMultiSelectDropdown"
    [options]="checkInLogsDisplayConfigurationOptions"
    [configurationInput]="checkInLogsDisplayConfigurationMultiSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #isDateShownDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.isDateShownSingleSelectDropdown"
    [options]="isDateShownOptions"
    [configurationInput]="isDateShownDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template
  #widgetRequestSingleSelectDropdown
  let-isFormSubmitted="isFormSubmitted"
  let-formControl="formControl"
  let-widgetSpecificContext="widgetSpecificContext"
>
  <widget-request-dropdown
    [formControl]="formControl"
    [widgetRequestCategoryFormControl]="widgetSpecificContext.widgetRequestCategoryFormControl"
    [isFormSubmitted]="isFormSubmitted"
    [dropdownLabel]="widgetSpecificContext?.dropdownLabel"
    [inputType]="widgetSpecificContext?.type"
    [resultType]="widgetSpecificContext?.resultType"
  ></widget-request-dropdown>
</ng-template>

<ng-template
  #widgetRequestCategorySingleSelectDropdown
  let-isFormSubmitted="isFormSubmitted"
  let-formControl="formControl"
  let-widgetSpecificContext="widgetSpecificContext"
>
  <widget-request-category-dropdown
    [formControl]="formControl"
    [isFormSubmitted]="isFormSubmitted"
    [type]="injectData.type"
    [dropdownLabel]="widgetSpecificContext.dropdownLabel"
  ></widget-request-category-dropdown>
</ng-template>

<ng-template #arithmeticOperatorDropdown let-isFormSubmitted="isFormSubmitted">
  <arithmetic-operator-dropdown
    [formControl]="formGroup.controls.arithmeticOperatorDropdown"
    [isFormSubmitted]="isFormSubmitted"
  ></arithmetic-operator-dropdown>
</ng-template>

<ng-template #ratioWidgetDisplayTypeDropdown let-isFormSubmitted="isFormSubmitted">
  <ratio-widget-display-type-dropdown
    [formControl]="formGroup.controls.ratioWidgetDisplayType"
    [isFormSubmitted]="isFormSubmitted"
  ></ratio-widget-display-type-dropdown>
</ng-template>

<ng-template #thresholdBasedColoringSelection let-isFormSubmitted="isFormSubmitted">
  <threshold-based-coloring-selection
    [formControl]="formGroup.controls.thresholdBasedColoringSelection"
    [isFormSubmitted]="isFormSubmitted"
  ></threshold-based-coloring-selection>
</ng-template>

<ng-template #formDataTypeDropdown let-isFormSubmitted="isFormSubmitted">
  @if (isCategoryFormSubmissions$ | async) {
    <form-data-type-dropdown
      [formControl]="formGroup.controls.formDataType"
      [isFormSubmitted]="isFormSubmitted"
    ></form-data-type-dropdown>
  }
</ng-template>

<ng-template #formFieldDropdown let-isFormSubmitted="isFormSubmitted">
  @if (isValueFromContentSetup$ | async) {
    <form-field-dropdown
      [formControl]="formGroup.controls.formField"
      [isFormSubmitted]="isFormSubmitted"
      [widgetRequestFormControl]="formGroup.controls[ETypeDependentInputs.widgetRequestSingleSelectDropdown]"
      [widgetRequestCategoryFormControl]="
        formGroup.controls[ETypeDependentInputs.widgetRequestCategorySingleSelectDropdown]
      "
    ></form-field-dropdown>
  }
</ng-template>

<ng-template #resultAggregationDropdown let-isFormSubmitted="isFormSubmitted">
  @if (isValueFromContentSetup$ | async) {
    <result-aggregation-dropdown
      [formControl]="formGroup.controls.resultAggregation"
      [isFormSubmitted]="isFormSubmitted"
    ></result-aggregation-dropdown>
  }
</ng-template>

<ng-template #textInput let-widgetSpecificContext="widgetSpecificContext" let-formControl="formControl">
  <mat-form-field appearance="outline">
    <mat-label>{{ 'page.widgetContent.addEditDialog.' + widgetSpecificContext?.label | translate }}</mat-label>
    <input matInput [formControl]="formControl" />
    <mat-error [control]="formControl"></mat-error>
  </mat-form-field>
</ng-template>

<ng-template #laborEfficiencyUnitDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.laborEfficiencyUnitDropdown"
    [options]="laborEfficiencyHourUnitOptions"
    [configurationInput]="laborEfficiencyHourUnitSingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #laborEfficiencyModeDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.laborEfficiencyModeDropdown"
    [options]="laborEfficiencyHourModeOptions"
    [configurationInput]="laborEfficiencyHourModeSingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>
<ng-template #nextFiveWorkOrderCountSingleSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.nextFiveWorkOrderCountSingleSelectDropdown"
    [options]="nextFiveWorkOrderCountOptions"
    [configurationInput]="nextFiveWorkOrderCountSingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #nextFiveWorkOrderListFieldOneSingleSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.nextFiveWorkOrderListFieldOneSingleSelectDropdown"
    [options]="nextFiveWorkOrderListFieldOptions"
    [configurationInput]="nextFiveWorkOrderListFieldOneSingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #nextFiveWorkOrderListFieldTwoSingleSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.nextFiveWorkOrderListFieldTwoSingleSelectDropdown"
    [options]="nextFiveWorkOrderListFieldOptions"
    [configurationInput]="nextFiveWorkOrderListFieldTwoSingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #nextFiveWorkOrderListFieldThreeSingleSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.nextFiveWorkOrderListFieldThreeSingleSelectDropdown"
    [options]="nextFiveWorkOrderListFieldOptions"
    [configurationInput]="nextFiveWorkOrderListFieldThreeSingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #nextFiveWorkOrderListFieldFourSingleSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.nextFiveWorkOrderListFieldFourSingleSelectDropdown"
    [options]="nextFiveWorkOrderListFieldOptions"
    [configurationInput]="nextFiveWorkOrderListFieldFourSingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #urlInput>
  <mat-form-field appearance="outline">
    <mat-label>{{ 'page.widgetContent.addEditDialog.url' | translate }}</mat-label>
    <input matInput [formControl]="formGroup.controls.url" />
    <mat-error [control]="formGroup.controls.url"></mat-error>
  </mat-form-field>
  <mat-label class="d-flex text-align-justify mb-3"
    >{{ 'page.widgetContent.addEditDialog.consentText' | translate }}
  </mat-label>
</ng-template>

<ng-template #displayIntervalInput>
  <mat-form-field appearance="outline">
    <mat-label>{{ 'page.widgetContent.addEditDialog.displayIntervalSeconds' | translate }}</mat-label>
    <input matInput type="number" [formControl]="formGroup.controls.displayIntervalInput" />
    <mat-error [control]="formGroup.controls.displayIntervalInput"></mat-error>
  </mat-form-field>
</ng-template>

<ng-template #showThumbnailCheckbox>
  <mat-checkbox class="d-block mb-xxl-3" [formControl]="formGroup.controls.showThumbnailCheckbox">
    {{ 'page.widgetContent.addEditDialog.showThumbnail' | translate }}
  </mat-checkbox>
</ng-template>

<ng-template #fitImageToWidgetCheckbox>
  <mat-checkbox class="d-block mb-xxl-3" [formControl]="formGroup.controls.fitImageToWidgetCheckbox">
    {{ 'page.widgetContent.addEditDialog.fitImageToWidget' | translate }}
  </mat-checkbox>
</ng-template>

<ng-template #comparisonSourceSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.comparisonSourceSelectDropdown"
    [options]="comparisonSourceOptions"
    [configurationInput]="comparisonSourceSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #fromLastNDaysInput>
  <mat-form-field appearance="outline">
    <mat-label>{{ 'page.widgetContent.addEditDialog.fromLastNDays' | translate }}</mat-label>
    <input matInput type="number" [formControl]="formGroup.controls.fromLastNDays" />
    <mat-error [control]="formGroup.controls.fromLastNDays"></mat-error>
  </mat-form-field>
</ng-template>

<ng-template
  #formSingleSelectDropdown
  let-isFormSubmitted="isFormSubmitted"
  let-widgetSpecificContext="widgetSpecificContext"
>
  <app-form-dropdown
    [formControl]="formGroup.controls.formSingleSelectDropdown"
    [isFormSubmitted]="isFormSubmitted"
    [selectedIdOnEdit]="widgetSpecificContext?.selectedIdOnEdit ?? null"
  >
  </app-form-dropdown>
</ng-template>

<ng-template #tableMappingDropdown let-isFormSubmitted="isFormSubmitted">
  <table-mapping-dropdown [formControl]="formGroup.controls.tableMapping" [isFormSubmitted]="isFormSubmitted">
  </table-mapping-dropdown>
</ng-template>

<ng-template
  #formAutofillSingleSelectDropdown
  let-isFormSubmitted="isFormSubmitted"
  let-widgetSpecificContext="widgetSpecificContext"
>
  <app-form-autofill-dropdown
    [formControl]="formGroup.controls.formAutofillSingleSelectDropdown"
    [isFormSubmitted]="isFormSubmitted"
    [selectedIdOnEdit]="widgetSpecificContext?.selectedIdOnEdit ?? null"
    [dashboardId]="dashboardId()"
    [workspaceId]="workspaceId()"
    [formId]="$any(formGroup.controls.formSingleSelectDropdown.value)[0]?.id"
  >
  </app-form-autofill-dropdown>
</ng-template>

<ng-template
  #endpointParameterMultiSelectDropdown
  let-isFormSubmitted="isFormSubmitted"
  let-widgetSpecificContext="widgetSpecificContext"
>
  @if (
    formGroup.controls.selectedWidget.value?.[0]?.id !== EWidget.bigNumber ||
    (formGroup.controls[ETypeDependentInputs.widgetRequestCategorySingleSelectDropdown].value.length &&
      formGroup.controls[ETypeDependentInputs.widgetRequestCategorySingleSelectDropdown].value[0].id ===
        EWidgetRequestCategory.dataSource)
  ) {
    <app-endpoint-parameter-dropdown
      [formControl]="formGroup.controls.endpointParameterMultiSelectDropdown"
      [isFormSubmitted]="isFormSubmitted"
      [selectedIdOnEdit]="widgetSpecificContext?.selectedIdOnEdit ?? null"
      [workspaceId]="workspaceId()"
      [widgetType]="formGroup.controls.selectedWidget.value?.[0]?.id ?? null"
    >
    </app-endpoint-parameter-dropdown>
  }
</ng-template>

<ng-template #formAssociation>
  <app-form-association
    [formControl]="formGroup.controls.formAssociation"
    [isFormSubmitted]="form.submitted"
  ></app-form-association>
</ng-template>

<ng-template #imageUpload>
  <app-image-upload
    [formControl]="formGroup.controls.imageUpload"
    [isFormSubmitted]="form.submitted"
    [canDeleteAttachments]="isEditingPersistedWidget"
  >
  </app-image-upload>
</ng-template>

<ng-template #shiftSelectionDropdown>
  <app-shift-selection
    [formControl]="formGroup.controls.shiftSelectionDropdown"
    [isFormSubmitted]="form.submitted"
    [isEditMode]="!!injectData.editData"
  ></app-shift-selection>
</ng-template>

<ng-template #escalationStatusSingleSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.escalationStatusSingleSelectDropdown"
    [options]="escalationStatusSingleSelectDropdownOptions"
    [configurationInput]="escalationStatusSingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #itemCategoryShiftConfigurations>
  <app-item-category-shift-configuration
    [formControl]="formGroup.controls.itemCategoryShiftConfigurations"
    [isFormSubmitted]="form.submitted"
  ></app-item-category-shift-configuration>
</ng-template>

<ng-template #boardScopeSingleSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.boardScopeSingleSelectDropdown"
    [options]="boardScopeOptions"
    [configurationInput]="boardScopeSingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>

<ng-template #excludeFutureDatesFromStatusColoringCheckbox>
  <mat-checkbox class="d-block mb-xxl-3" [formControl]="formGroup.controls.excludeFutureDatesFromStatusColoringCheckbox">
    {{ 'page.widgetContent.addEditDialog.excludeFutureDatesFromStatusColoring' | translate }}
  </mat-checkbox>
</ng-template>

<ng-template #datatableConfigurationInput let-widgetSpecificContext="widgetSpecificContext">
  <datatable-configuration-input
    [formControl]="formGroup.controls.datatableConfiguration"
    [availableStandardHeaders]="widgetSpecificContext.availableStandardHeaders"
    [store]="widgetSpecificContext.store"
    [pageConfigurationBuilder]="widgetSpecificContext.pageConfigurationBuilder"
    [defaultHeaders]="widgetSpecificContext.defaultHeaders"
  ></datatable-configuration-input>
</ng-template>

<ng-template #sortBySingleSelectDropdown>
  <mat-dropdown
    [formControl]="formGroup.controls.sortBySingleSelectDropdown"
    [options]="sortByOptions"
    [configurationInput]="sortBySingleSelectDropdownConfiguration"
    [isFormSubmitted]="form.submitted"
  ></mat-dropdown>
</ng-template>
